var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7 3C18.092 3 22.578 6.88 23.519 12C22.579 17.12 18.092 21 12.7 21C7.30804 21 2.82204 17.12 1.88104 12C2.82104 6.88 7.30804 3 12.7 3ZM12.7 19C14.7395 18.9996 16.7184 18.3068 18.3129 17.0352C19.9074 15.7635 21.0229 13.9883 21.477 12C21.0213 10.0133 19.905 8.24 18.3107 6.97003C16.7164 5.70005 14.7383 5.00853 12.7 5.00853C10.6617 5.00853 8.68373 5.70005 7.08942 6.97003C5.4951 8.24 4.37881 10.0133 3.92304 12C4.37714 13.9883 5.49272 15.7635 7.08719 17.0352C8.68166 18.3068 10.6606 18.9996 12.7 19ZM12.7 16.5C11.5066 16.5 10.362 16.0259 9.51806 15.182C8.67415 14.3381 8.20004 13.1935 8.20004 12C8.20004 10.8065 8.67415 9.66193 9.51806 8.81802C10.362 7.97411 11.5066 7.5 12.7 7.5C13.8935 7.5 15.0381 7.97411 15.882 8.81802C16.7259 9.66193 17.2 10.8065 17.2 12C17.2 13.1935 16.7259 14.3381 15.882 15.182C15.0381 16.0259 13.8935 16.5 12.7 16.5ZM12.7 14.5C13.3631 14.5 13.999 14.2366 14.4678 13.7678C14.9367 13.2989 15.2 12.663 15.2 12C15.2 11.337 14.9367 10.7011 14.4678 10.2322C13.999 9.76339 13.3631 9.5 12.7 9.5C12.037 9.5 11.4011 9.76339 10.9323 10.2322C10.4634 10.7011 10.2 11.337 10.2 12C10.2 12.663 10.4634 13.2989 10.9323 13.7678C11.4011 14.2366 12.037 14.5 12.7 14.5Z",
    fill: "#344767"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.42f068ee5b5ef000558245bf5c5588db.svg";
export { ForwardRef as ReactComponent };